// src/pages/OnboardingDetailPage.tsx
// MAIN FILE - Imports all parts and assembles the complete component

import React from 'react';
import './OnboardingDetailPage.css';
import { useOnboardingDetailLogic } from './OnboardingDetailPage-part2';
import { RenderMainContent } from './OnboardingDetailPage-part3';

const OnboardingDetailPage: React.FC = () => {
  // Get all state and handlers from the custom hook (Part 2)
  const logic = useOnboardingDetailLogic();

  // Render the main content using Part 3
  return (
    <RenderMainContent
      onboarding={logic.onboarding}
      loading={logic.loading}
      error={logic.error}
      expandedSteps={logic.expandedSteps}
      showApprovalModal={logic.showApprovalModal}
      setShowApprovalModal={logic.setShowApprovalModal}
      showRejectionModal={logic.showRejectionModal}
      setShowRejectionModal={logic.setShowRejectionModal}
      showStepActionModal={logic.showStepActionModal}
      setShowStepActionModal={logic.setShowStepActionModal}
      selectedStep={logic.selectedStep}
      actionType={logic.actionType}
      actionNotes={logic.actionNotes}
      setActionNotes={logic.setActionNotes}
      rejectionReason={logic.rejectionReason}
      setRejectionReason={logic.setRejectionReason}
      processing={logic.processing}
      toggleStep={logic.toggleStep}
      handleStepAction={logic.handleStepAction}
      executeStepAction={logic.executeStepAction}
      handleFinalApproval={logic.handleFinalApproval}
      handleFinalRejection={logic.handleFinalRejection}
      navigate={logic.navigate}
      loadOnboardingDetails={logic.loadOnboardingDetails}
    />
  );
};

export default OnboardingDetailPage;